// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chip {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 26px;
  padding-inline: 14px;
  background-color: var(--ion-color-secondary);
  border-radius: var(--radius-default);
}
.chip p {
  font-family: AppFontBold;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: capitalize;
  color: #fff;
}
.chip .table {
  margin-right: 3px;
}
.chip ion-icon {
  margin-left: 5px;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/components/chip-table/chip-table.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EAEA,4CAAA;EACA,oCAAA;AAAD;AACC;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;EACA,WAAA;AACF;AACC;EACC,iBAAA;AACF;AAGC;EACC,gBAAA;EACA,YAAA;AADF","sourcesContent":[".chip {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\theight: 26px;\n\tpadding-inline: 14px;\n\n\tbackground-color: var(--ion-color-secondary);\n\tborder-radius: var(--radius-default);\n\tp {\n\t\tfont-family: AppFontBold;\n\t\tfont-size: 12px;\n\t\tline-height: 100%;\n\t\tletter-spacing: 0%;\n\t\tvertical-align: middle;\n\t\ttext-transform: capitalize;\n\t\tcolor: #fff;\n\t}\n\t.table {\n\t\tmargin-right: 3px;\n\t}\n\t.number {\n\t}\n\tion-icon {\n\t\tmargin-left: 5px;\n\t\tcolor: white;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
